__turbopack_context__.v({
  "desktopNav": "AssetLinks-module__yGXn5G__desktopNav",
  "icon": "AssetLinks-module__yGXn5G__icon",
  "mobileLink": "AssetLinks-module__yGXn5G__mobileLink",
  "mobileNav": "AssetLinks-module__yGXn5G__mobileNav",
});
